import { Tag, TagType } from "../types/Tagging.types";
import apiFetch from './index';

export async function getTagsByType(type: TagType) {
    const tags: Tag[] = await (await apiFetch(`/api/tags/byType/${type}`, {
        headers: {
            'Accept': 'application/json',
        },
        credentials: 'include'
    })).json();
    return tags;
}

export async function editTag(tag: Tag) {
    let url = '/api/tags';
    if (tag.Id && tag.Id > 0) url += '/' + tag.Id;
    const result = await apiFetch(url, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(tag),
    });
    return await result.json() as Tag;
}

export async function searchTags(searchStr: string, type?: TagType) {
    let url = '/api/tags/search';
    if (Boolean(type)) url += 'byType';
    const result = await apiFetch(url, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
            query: searchStr,
            type
        })
    });
    return await result.json() as Tag[];
}

export async function assignTags(entityId: number, entityType: 'user' | 'desk', tags: Tag[]) {
    let success = true;
    await apiFetch(`/api/tags/assign/${entityType}/${entityId}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(tags.map(t => t.Id))
    }).catch(r => success = false);
    return success;   
}
